import Stats from './Stats.vue'

export default Stats
